import ActivateUserAccount from './ActivateUserAccount';

export default ActivateUserAccount;
